export default __webpack_public_path__ + "static/media/ART3.be047bdf.jpg";